import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    IconButton,
    Radio,
    RadioGroup
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { getRequest, postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import "./style.css";
import { DatePicker } from '@mui/x-date-pickers';
import { formatDate } from 'src/services/fetching';

export const TestSendEmailModal = ({ open, onClose, row }) => {
    console.log("🚀 ~ TestEmailModal ~ row:", row);
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);

    // Initialize startDate and endDate with default values
    const [ startDate, setStartDate ] = useState(new Date());
    console.log("🚀 ~ TestSendEmailModal ~ startDate:", startDate)
    const [ endDate, setEndDate ] = useState(new Date());

    const [ selectedGroup, setSelectedGroup ] = useState("all_registered");
    const [ data, setData ] = useState({});


    // API Fetch Function
    const getUsers = async () => {
        const formattedStartDate = startDate.toISOString().split('T')[ 0 ];
        const formattedEndDate = endDate.toISOString().split('T')[ 0 ];

        const url = `${endpoints.admin_dashboard.product_updates.newsletter.get_email_modal_details}?group=${selectedGroup}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
        try {
            const response = await getRequest(url);
            console.log("🚀 ~ getUsers ~ response:", response)
            setData(response);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (open) {
            getUsers();
        }
    }, [ startDate, endDate, selectedGroup, open ]);

    const NewDocumentSchema = Yup.object().shape({});

    const defaultValues = useMemo(() => ({}), []);

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('send_to', selectedGroup);
        formData.append('start_date', formatDate(startDate));
        formData.append('end_date', formatDate(endDate));
        try {
            const response = await postRequest(
                `${endpoints.admin_dashboard.product_updates.newsletter.filter_date_email_send}/${row.id}`,
                formData,
                true
            ); if (response.metadata?.success) {
                reset();
                onClose();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
            scroll={ "body" }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Send Email  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box mt={ 2 } display="grid" gap={ 2 }>
                        <Box
                            sx={ {
                                backgroundColor: '#2196F3',
                                color: 'white',
                                padding: '12px',
                                borderRadius: '8px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                            } }
                        >
                            <Box sx={ { display: 'flex', alignItems: 'center', gap: '10px' } }>
                                <Iconify icon="mdi:information" width={ 24 } height={ 24 } />
                                <strong>Note:</strong> Email will be sent to <strong>{ data?.count || 0 }</strong> users.
                            </Box>
                            <Divider sx={ { backgroundColor: 'white', opacity: 0.6 } } />
                            <Box>
                                { data?.duration || 'Email recipients: who registered between --- and ---' }
                            </Box>
                        </Box>
                    </Box>

                    <Box mt={ 4 } display="grid" gap={ 2 } gridTemplateColumns="repeat(2, 1fr)">
                        <DatePicker
                            label="From Date"
                            value={ startDate }
                            onChange={ setStartDate }
                            slotProps={ { textField: { fullWidth: true } } }
                        />
                        <DatePicker
                            label="To Date"
                            value={ endDate }
                            onChange={ setEndDate }
                            slotProps={ { textField: { fullWidth: true } } }
                        />
                    </Box>

                    <Box mt={ 2 } display="grid">
                        <RadioGroup
                            row
                            value={ selectedGroup }
                            onChange={ (e) => setSelectedGroup(e.target.value) }
                        >
                            <FormControlLabel value="all_registered" control={ <Radio size="medium" /> } label="All Registered Users" />
                            <FormControlLabel value="subscribed" control={ <Radio size="medium" /> } label="Subscribed Users" />
                            <FormControlLabel value="verified" control={ <Radio size="medium" /> } label="Verified Users" />
                            <FormControlLabel value="non_verified" control={ <Radio size="medium" /> } label="Non Verified Users" />
                            <FormControlLabel value="newsletter" control={ <Radio size="medium" /> } label="Newsletter Users" />
                        </RadioGroup>
                    </Box>

                    <Divider />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Submit
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};